var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"farme-spinner"},[_c('v-progress-linear',{staticClass:"mt-0 mb-0",attrs:{"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }